import { createReducer, on } from '@ngrx/store';
import { setPlotType } from './plot-type.actions';
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
import { ScatterPlotPlotType } from 'ChartApp/ts/enums/scatter-plot-common.enum';
export const plotType = createReducer(ScatterPlotPlotType.pointInTime, on(setPlotType, (state, action) => {
    return action.plotType;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.plotType;
}));
